export function verifiedMemberEmails(member) {
  const seen = new Set();
  return (member?.verified_emails || [])
    .map((email) => String(email || '').trim().toLowerCase())
    .filter((email) => {
      if (!email || seen.has(email)) return false;
      seen.add(email);
      return true;
    });
}

export function teamMemberEmailMode(member) {
  if (!member?.user_id && member?.email_linked_to_user !== true) return 'editable';
  return verifiedMemberEmails(member).length > 1 ? 'select' : 'locked';
}

export function teamMemberEmailPayload(member, nextEmail) {
  if (teamMemberEmailMode(member) === 'locked') return {};
  const normalized = String(nextEmail || '').trim().toLowerCase();
  if (
    teamMemberEmailMode(member) === 'select'
    && normalized === String(member?.email || '').trim().toLowerCase()
  ) {
    return {};
  }
  return { email: nextEmail };
}
